import { Theme } from '@mui/material';

type NavIconColorsParams = {
  readonly theme: Theme;
  readonly active: boolean;
  readonly labelColor: string;
  readonly activeColor?: string;
  readonly activeSecondaryColor?: string;
};

export const getNavIconColors = ({
  theme,
  active,
  labelColor,
  activeColor,
  activeSecondaryColor,
}: NavIconColorsParams) => {
  if (active && activeColor) {
    return {
      color: activeColor,
      primaryColor: activeColor,
      secondaryColor: activeSecondaryColor ?? activeColor,
    };
  }
  return {
    color: labelColor,
    primaryColor: theme.palette.neutral[600],
    secondaryColor: theme.palette.neutral[400],
  };
};
